import CONST from './model/const'
import App from './app'
               
const app = new App({
  auth:{
  app_id: "0e8cff07",
  third_party_user_id:'492',
  access_token: "access:0e8cff07:f703379d24178ff0"
  }
})

export default {
  VHall_Questionnaire_Service: App,
  VHall_Questionnaire_Const: CONST
}
